import React, { useEffect } from 'react';
import { useAdminContext } from 'src/contexts/admin.context';
import { actionTypes } from 'src/ducks/admin.duck';
import { getAdminStatus } from 'src/selectors/admin.selector';
import RoleMaintenanceView from './role-maintenance-list.view';

const RoleMaintenance: React.FC = () => {
  const { state, actions } = useAdminContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <RoleMaintenanceView
      loading={getAdminStatus(state, actionTypes.ADMIN_LIST_FETCH).fetching}
      data={state.list}
    />
  );
};

export default RoleMaintenance;
